import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EventWithScenarios } from '../../../common/types';
import { ShareButton } from '../../../components/ShareButton';
import { CreateEventModal } from './create';
import { BreadcrumbGroup } from '@cloudscape-design/components';

export type EventsViewProps = {
  events: EventWithScenarios[];
};

export function EventsView(props: EventsViewProps) {
  const { events } = props;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div>
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-3xl font-bold mb-6">Events</h1>
        <button
          className="bg-white text-black py-2 px-4 rounded hover:bg-gray-200 transition-colors duration-300"
          onClick={(e) => {
            e.preventDefault();
            setOpen(true);
          }}
        >
          Create
        </button>
      </div>

      {/* Grid Layout for Event Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {events.map((event) => (
          <div
            key={event.eventUuid}
            className="bg-[#1e2a38] p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
          >
            {/* Event Name and Code */}
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-white text-xl font-bold">{event.name}</h3>
              <ShareButton eventUuid={event.eventUuid} />
            </div>

            {/* Event Details */}
            <div className="text-gray-300 mb-4">
              <p>Scenarios: {event.scenarios.length}</p>
              <p>
                Rooms: {event.scenarios.reduce((acc, scenario) => acc + scenario.rooms.length, 0)}
              </p>
            </div>

            {/* Join Button */}
            <div className="flex justify-end">
              <button
                className="bg-white text-black py-2 px-4 rounded hover:bg-gray-200 transition-colors duration-300 mx-auto w-full"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/manage/events/${event.eventUuid}`);
                }}
              >
                View Event
              </button>
            </div>
          </div>
        ))}
      </div>
      <CreateEventModal open={open} setOpen={setOpen} />
    </div>
  );
}
